module.exports = __webpack_public_path__ + "static/team-28-4a166a95b541b054aa7c5e0d678397e5.jpg";